import { Row } from "antd";
import styled from "styled-components";

export const ServiceSection = styled("section")`
  position: relative;
  padding: 2rem 0 6rem;

  @media only screen and (max-width: 1024px) {
    padding: 2rem 0 4rem;
  }
`;

export const Content = styled("p")`
  margin: 1.5rem 0 2rem 0;
`;

export const StyledRow = styled(Row) <{ direction?: string }>`
  // Remove or avoid flex-direction based on 'direction' prop
  // Ensure horizontal layout:
  flex-direction: row !important;
`;


export const ContentHead = styled("div")`
  text-align: left;
  font-family: 'Gilroy Bold', serif;
  color: #2A3273;
  font-size: 25px;

  @media only screen and (max-width: 890px) {
    font-size: 18px;
  }

  @media only screen and (max-width: 414px) {
    font-size: 18px;
  }
`;

export const ContentText = styled("div")`
  font-family: 'Gilroy Bold', serif;
  color: #2159A6;
  text-align: left;
  font-size: 50px;
  
  @media only screen and (max-width: 890px) {
    font-size: 28px;
  }

  @media only screen and (max-width: 414px) {
    font-size: 28px;
  }
`;

export const ContentTextSmall = styled("div")`
  font-family: 'Gilroy Light', serif;
  color: #000000;
  text-align: left;
  font-size: 22px;

  @media only screen and (max-width: 890px) {
    font-size: 14px;
  }

  @media only screen and (max-width: 414px) {
    font-size: 14px;
  }
`;

export const VerticalButtonList = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* 3 columns */
    grid-gap: 10px;
    justify-items: center;
  }
`;



export const CountyButton = styled.div<{ selected?: boolean }>`
  width: 300px;
  text-align: left;
  margin-bottom: 8px;
  font-family: 'Gilroy Semibold', serif;
  font-size: 40px;
  color: ${({ selected }) => (selected ? "#2A3273" : "#2159A6")};
  cursor: default;

  @media only screen and (max-width: 768px) {
    width: 100px;
    height: 45px;
    font-size: 16px;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-family: 'Gilroy Semibold', serif;

    border: 1px solid #2159A6;
    border-radius: 20px;
    background-color: ${({ selected }) => (selected ? "#2159A6" : "#FFFFFF")};
    color: ${({ selected }) => (selected ? "#FFFFFF" : "#2159A6")};
    cursor: pointer;
    transition: all 0.3s;
  }

  @media only screen and (max-width: 414px) {
    font-size: 15px;
    font-family: 'Gilroy Semibold', serif;
  }

  @media only screen and (min-width: 769px) {
    &:hover {
      color: #2A3273;
    }
  }
`;
